export default __webpack_public_path__ + "static/media/Image4.4e58f61f.JPG";